import { css as g, LitElement as v, nothing as p, html as d } from "lit";
import { property as o, customElement as b } from "lit/decorators.js";
import { b as u } from "./styles-scZ6dVz-.js";
var h = Object.defineProperty, f = Object.getOwnPropertyDescriptor, e = (l, t, c, s) => {
  for (var a = s > 1 ? void 0 : s ? f(t, c) : t, n = l.length - 1, i; n >= 0; n--)
    (i = l[n]) && (a = (s ? i(t, c, a) : i(a)) || a);
  return s && a && h(t, c, a), a;
};
let r = class extends v {
  constructor() {
    super(...arguments), this.label = "", this.value = "", this.trend = "", this.variant = "default", this.size = "default";
  }
  render() {
    return d`
      <div class="card" part="card">
        <div class="header" part="header">
          <div class="icon-wrapper">
            <slot name="icon"></slot>
          </div>
          <span class="label">${this.label}</span>
        </div>
        <div class="content" part="content">
          <span class="value">${this.value}</span>
          ${this.trend ? d`<span class="trend">${this.trend}</span>` : p}
        </div>
      </div>
    `;
  }
};
r.styles = [
  u,
  g`
      :host {
        display: block;
      }

      .card {
        background-color: var(--r5-bg-surface);
        border: 1px solid var(--r5-border);
        border-radius: var(--r5-radius-lg);
        padding: var(--r5-space-5);
        height: 100%;
        display: flex;
        flex-direction: column;
        gap: var(--r5-space-3);
        transition: box-shadow var(--r5-duration-normal);
        position: relative;
        overflow: hidden;
      }

      /* Variants - using fallback RGB values */
      :host([variant='success']) .card {
        background: linear-gradient(135deg, var(--r5-bg-surface) 0%, rgba(var(--r5-color-success-500-rgb, 34, 197, 94), 0.05) 100%);
        border-color: rgba(var(--r5-color-success-500-rgb, 34, 197, 94), 0.2);
      }

      :host([variant='error']) .card {
        background: linear-gradient(135deg, var(--r5-bg-surface) 0%, rgba(var(--r5-color-danger-500-rgb, 239, 68, 68), 0.05) 100%);
        border-color: rgba(var(--r5-color-danger-500-rgb, 239, 68, 68), 0.2);
      }

      :host([variant='warning']) .card {
        background: linear-gradient(135deg, var(--r5-bg-surface) 0%, rgba(var(--r5-color-warning-500-rgb, 245, 158, 11), 0.05) 100%);
        border-color: rgba(var(--r5-color-warning-500-rgb, 245, 158, 11), 0.2);
      }

      :host([variant='info']) .card {
        background: linear-gradient(135deg, var(--r5-bg-surface) 0%, rgba(var(--r5-color-info-500-rgb, 59, 130, 246), 0.05) 100%);
        border-color: rgba(var(--r5-color-info-500-rgb, 59, 130, 246), 0.2);
      }

      /* Compact size */
      :host([size='compact']) .card {
        padding: var(--r5-space-3);
        gap: var(--r5-space-2);
      }

      :host([size='compact']) .icon-wrapper {
        width: 1.5rem;
        height: 1.5rem;
      }

      :host([size='compact']) .icon-wrapper ::slotted(*) {
        width: 0.875rem;
        height: 0.875rem;
      }

      :host([size='compact']) .value {
        font-size: var(--r5-text-xl);
      }

      .header {
        display: flex;
        align-items: center;
        gap: var(--r5-space-2);
      }

      .icon-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 2rem;
        height: 2rem;
        border-radius: var(--r5-radius-md);
        background-color: var(--r5-bg-muted);
        color: var(--r5-text-muted);
        flex-shrink: 0;
      }

      /* Style slotted content - the span wrapper and its SVG child */
      .icon-wrapper ::slotted(*) {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 1rem;
        height: 1rem;
      }

      :host([variant='success']) .icon-wrapper {
        background-color: rgba(var(--r5-color-success-500-rgb, 34, 197, 94), 0.1);
        color: var(--r5-color-success-600, #16a34a);
      }

      :host([variant='error']) .icon-wrapper {
        background-color: rgba(var(--r5-color-danger-500-rgb, 239, 68, 68), 0.1);
        color: var(--r5-color-danger-600, #dc2626);
      }

      :host([variant='warning']) .icon-wrapper {
        background-color: rgba(var(--r5-color-warning-500-rgb, 245, 158, 11), 0.1);
        color: var(--r5-color-warning-600, #d97706);
      }

      :host([variant='info']) .icon-wrapper {
        background-color: rgba(var(--r5-color-info-500-rgb, 59, 130, 246), 0.1);
        color: var(--r5-color-info-600, #2563eb);
      }

      .label {
        font-size: var(--r5-text-xs);
        font-weight: var(--r5-font-bold);
        text-transform: uppercase;
        letter-spacing: 0.05em;
        color: var(--r5-text-muted);
      }

      :host([variant='success']) .label { color: var(--r5-color-success-600, #16a34a); }
      :host([variant='error']) .label { color: var(--r5-color-danger-600, #dc2626); }
      :host([variant='warning']) .label { color: var(--r5-color-warning-600, #d97706); }
      :host([variant='info']) .label { color: var(--r5-color-info-600, #2563eb); }

      .content {
        display: flex;
        flex-direction: column;
        gap: var(--r5-space-1);
      }

      .value {
        font-size: var(--r5-text-3xl);
        font-weight: var(--r5-font-bold);
        color: var(--r5-text);
        line-height: 1.2;
      }

      .trend {
        font-size: var(--r5-text-xs);
        color: var(--r5-text-muted);
      }
    `
];
e([
  o()
], r.prototype, "label", 2);
e([
  o()
], r.prototype, "value", 2);
e([
  o()
], r.prototype, "trend", 2);
e([
  o({ reflect: !0 })
], r.prototype, "variant", 2);
e([
  o({ reflect: !0 })
], r.prototype, "size", 2);
r = e([
  b("ark-stats-card")
], r);
export {
  r as A
};
//# sourceMappingURL=ark-stats-card-C-rq8arv.js.map
